import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  background-color: ${ColorPalette.HEX.Lotion};

  @media ${({ theme }) => theme.device.desktop} {
    background: ${ColorPalette.Transparent};
    max-width: 1300px;
  }
`;

export const ReportFiltersContainer: any = styled.div`
  padding: 20px 16px;
  display: flex;
  min-height: 420px;
  flex-direction: column;
  justify-content: space-between;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    min-height: 0;
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.group.division};
`;
